@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('isView')) {
    <div class="container-fluid mb-4">
      <div class="leaveManagmentParent" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <div class="leftLM">
          <p class="headingattandace">Event Management</p>
        </div>
        @if (isavailablefeature('isAdd')) {
          <div class="rightLM">
            <button type="button" class="btnEvent" routerLink="/create-event">
              + Create Event
            </button>
          </div>
        }
      </div>
      <!-- 2nd row -->
      <!-- <div class="parentFilter">
      <div class="leftsideFilter">
        <p class="headingFilter">Filter</p>
      </div>
      <div class="rightsideFilter">
        <div class="txtboxName">
          <input type="text" placeholder="Search by Name" />
        </div>
        <div class="txtboxStartdate">
          <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Start Date" />
        </div>
        <div class="txtboxEnddate">
          <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="End Date" />
        </div>
        <div class="btnApply"><button type="button">Apply</button></div>
      </div>
    </div> -->
    <!-- tabs buttons -->
    <div class="col-12 main-div pl-0">
      <div class="parentCurrentYear col-6 pl-0">
        <button type="button" class="col-4" (click)="showupComing()"
          [ngClass]="{ btnupComing: isupComing, btnpastevent: isPast }">
          Up Comming Events
        </button>
        <button type="button" class="col-4" (click)="showPastevent()"
          [ngClass]="{ btnupComing: isPast, btnpastevent: isupComing }">
          Past Events
        </button>
      </div>
    </div>
    @if (isupComing) {
      <div class="mt-0">
        <section class="cards mt-3">
          <!--   card 1 -->
          @for (data of apidata; track data) {
            <article class="card" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <picture class="thumbnail">
                <img class="category__01" src="{{ data.event_image }}" alt="Image Missing" />
              </picture>
              <div class="card-content">
                <p class="category category__01">{{ replaceUnderscores(data.event_type) }}</p>
                <h2>{{ data.event_name }}</h2>
                <p class="text-justify">{{ data.event_description }}</p>
              </div>
              <!-- .card-content -->
              <div class="post-meta ">
                <div class="col-12 row">
                  <div class="col-6">
                    <span class="timestamp"><i class="fa fa-calendar mr-2"></i>{{ data.event_date }}</span><br>
                  </div>
                  <div class="col-6">
                    <span class="timestamp"><i class="fa fa-map-marker mr-2"></i>{{ data.event_location }}</span>
                  </div>
                </div>
              </div>
              <footer class="row">
                <div class="update-event col-12 p-0 d-flex justify-content-around">
                  @if (isavailablefeature('isDelete')) {
                    <div class="btn btn-danger delete-event col-5 " (click)="deleteevent(data.id)">
                      <span class="icons delete"><i class="fa fa-trash-o  m-0"></i> </span>
                    </div>
                  }
                  @if (isavailablefeature('isEdit')) {
                    <div class="btn btn-primary edit_event col-5" (click)="editeevent(data.id)">
                      <span class="icons edit"><i class="fa fa-edit"></i></span>
                    </div>
                  }
                </div>
              </footer>
            </article>
          }
        </section>
      </div>
    }
    @if (isPast) {
      <div class="mt-0">
        <section class="cards mt-3">
          @for (data of pastdata; track data) {
            <article class="card" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <picture class="thumbnail">
                <img class="category__01" src="{{ data.event_image }}" alt="Image Missing" />
              </picture>
              <div class="card-content">
                <p class="category category__01">{{ replaceUnderscores(data.event_type) }}</p>
                <h2>{{ data.event_name }}</h2>
                <p>{{ data.event_description }}</p>
              </div>
              <!-- .card-content -->
              <div class="post-meta ">
                <div class="col-12 row">
                  <div class="col-6">
                    <span class="timestamp"><i class="fa fa-calendar mr-2"></i>{{ data.event_date }}</span><br>
                  </div>
                  <div class="col-6">
                    <span class="timestamp"><i class="fa fa-map-marker mr-2"></i>{{ data.event_location }}</span>
                  </div>
                </div>
              </div>
              <footer class="row">
                <div class="update-event col-12 p-0 d-flex justify-content-around">
                  @if (isavailablefeature('isDelete')) {
                    <div class="btn btn-danger delete-event col-5 " (click)="deleteevent(data.id)">
                      <span class="icons delete"><i class="fa fa-trash-o  m-0"></i> </span>
                    </div>
                  }
                  @if (isavailablefeature('isEdit')) {
                    <div class="btn btn-primary edit_event col-5" (click)="editeevent(data.id)">
                      <span class="icons edit"><i class="fa fa-edit"></i></span>
                    </div>
                  }
                </div>
              </footer>
            </article>
          }
        </section>
      </div>
    }
  </div>
}
</main>